module.exports = __webpack_public_path__ + "img/485.705b84e4.jpg";